const getRandomNumber = () =>
  window.crypto.getRandomValues(new Uint32Array(1))[0] / 2 ** 32;

export default getRandomNumber;
